exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".save-document-form[data-v-0f46f951]{margin:auto}.filter-tabs[data-v-0f46f951]{width:100%!important}.card-hover-btn .delete-btn[data-v-0f46f951]{top:-70px}.card-hover-btn .delete-btn span[data-v-0f46f951]{width:180px}.project-tag[data-v-0f46f951]{height:0}.project-tag .project-name[data-v-0f46f951]{background:#23a6cd;color:#fff;visibility:visible;opacity:1;left:0;position:relative;font-size:18px;border-bottom-right-radius:6px;border-top-right-radius:6px;width:70%;box-shadow:0 5px 15px 0 rgb(0 0 0/50%);bottom:50px;font-weight:400;padding:5px 15px}", ""]);

// exports
